import * as React from "react";

function SvgWarning(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="83" height="83" viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M41.5 76.0834C60.5999 76.0834 76.0834 60.5999 76.0834 41.5C76.0834 22.4002 60.5999 6.91669 41.5 6.91669C22.4002 6.91669 6.91669 22.4002 6.91669 41.5C6.91669 60.5999 22.4002 76.0834 41.5 76.0834ZM34.5834 13.8334L38.0417 48.4167H44.9584L48.4167 13.8334H34.5834ZM41.5 69.1667C45.32 69.1667 48.4167 66.07 48.4167 62.25C48.4167 58.43 45.32 55.3334 41.5 55.3334C37.6801 55.3334 34.5834 58.43 34.5834 62.25C34.5834 66.07 37.6801 69.1667 41.5 69.1667Z" fill="#F7A246"/>
    </svg>

  );
}

export default SvgWarning;
